import { gsap } from 'gsap';

document.addEventListener(
	'CarouselReady',
	() => {
		const carousels = window.sliderList;
		const index = carousels.findIndex((carousel) => carousel.id === 'specialSelection');
		const specialCarousel = carousels[index].slide;
		let lastActiveIndex = null;
		const cards = document.querySelectorAll('.special-selection .card-selection');
		const randomButton = document.querySelector('.special-selection__random');

		// Function to set active class in centered card
		function updateActiveCard(info) {
			const { index: indexCurr } = info;

			if (lastActiveIndex !== null && lastActiveIndex < cards.length) {
				cards[lastActiveIndex].classList.remove('active');
			}

			if (indexCurr < cards.length) {
				cards[indexCurr].classList.add('active');
				lastActiveIndex = indexCurr;
				specialCarousel.refresh();
			}
		}

		specialCarousel.events.on('transitionEnd', updateActiveCard);

		// Add functionality to the random button
		randomButton.addEventListener('click', () => {
			const info = specialCarousel.getInfo();
			const { slideCount, index: currentIndex } = info;
			let randomIndex = currentIndex;

			// Generate a new random index different from the current index
			do {
				randomIndex = Math.floor(Math.random() * slideCount);
			} while (randomIndex === currentIndex);

			specialCarousel.goTo(randomIndex);
		});

		// Function to calculate necessary items, clone them to fill the viewport, and initiate a continuous animation.
		function initializeBannerAnimation() {
			const itemWidth = document.querySelector('.special-selection__banner__item').offsetWidth;
			const viewportWidth = window.innerWidth;
			const itemsNeeded = Math.ceil(viewportWidth / itemWidth) + 1;

			// Clone banner items to ensure the banner can fill the viewport continuously
			for (let i = 0; i < itemsNeeded; i++) {
				const clone = document.querySelector('.special-selection__banner__item').cloneNode(true);
				document.querySelector('.special-selection__banner').appendChild(clone);
			}

			const totalWidth = document.querySelectorAll('.special-selection__banner__item').length * itemWidth;

			gsap.to('.special-selection__banner__item', {
				x: `-${totalWidth}px`,
				ease: 'linear',
				duration: 50,
				repeat: -1,
			});
		}

		initializeBannerAnimation();
	},
	false,
);
